import { render, staticRenderFns } from "./PostPackageGroupsView.vue?vue&type=template&id=5827ba57"
import script from "./PostPackageGroupsView.vue?vue&type=script&lang=js"
export * from "./PostPackageGroupsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports